export default __webpack_public_path__ + "static/media/host_naviTeam_disable.ee10905a.svg";